// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n1-1";
export var messageSideRight = "_n1-2";
export var orderLookupBubbleContainer = "_n1-0";
export var submitButton = "_n1-3";